import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_MECHANIC_CERTIFICATION_TABLE = 'FETCH_MECHANIC_CERTIFICATION_TABLE'
export const RECEIVE_MECHANIC_CERTIFICATION_TABLE = 'RECEIVE_MECHANIC_CERTIFICATION_TABLE'
export const FAILED_MECHANIC_CERTIFICATION_TABLE = 'FAILED_MECHANIC_CERTIFICATION_TABLE'

export function fetchMechanicCertification(id_mechanic){


    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_MECHANIC_CERTIFICATION_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.MECHANIC_CERTIFICATION_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_mechanic:id_mechanic
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_MECHANIC_CERTIFICATION_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_MECHANIC_CERTIFICATION_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_MECHANIC_CERTIFICATION_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_MECHANIC_CERTIFICATION_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_MECHANIC_CERTIFICATION_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_MECHANIC_CERTIFICATION_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_MECHANIC_CERTIFICATION_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}